/**
 * Chuỗi của bán token Fox (ADR-0100): gói nạp token, đơn giá token Fox, nút lấy tỷ giá Vietcombank, hệ số token của
 * model, hộp gửi yêu cầu nạp token, ảnh chụp giá, bảng theo model. Tách tệp để dựng song song; khoá cấp một `banToken`,
 * sâu tối đa hai cấp dưới nó.
 */
export const viBanToken = {
  banToken: {
    chung: {
      usd: '{{so}} USD',
      xapXiVnd: '≈ {{so}} ₫',
      soTokenFox: '{{so}} token Fox',
    },
    goiNap: {
      timTheo: 'Tìm theo tên hoặc mã',
      timNhan: 'Tìm gói nạp token',
      locTrangThai: 'Lọc theo trạng thái',
      tatCaTrangThai: 'Mọi trạng thái',
      dangBan: 'Đang bán',
      daNgung: 'Đã ngừng',
      taoGoi: 'Tạo gói',
      suaGoi: 'Sửa gói',
      batGoi: 'Bán lại',
      ngungGoi: 'Ngừng bán',
      luu: 'Lưu gói',
      cotTen: 'Gói',
      cotToken: 'Token Fox',
      cotThoiHan: 'Thời hạn',
      cotGia: 'Giá',
      giaRieng: 'Giá riêng',
      giaTheoDonGia: 'Theo đơn giá',
      chuaCoGia: 'Chưa có giá',
      bangCaption: 'Danh mục gói nạp token',
      rongThat: 'Chưa có gói nạp token',
      rongThatMo: 'Tạo gói để tổ chức chọn khi gửi yêu cầu nạp token.',
      rongLoc: 'Không có gói khớp bộ lọc',
      loiDanhSach: 'Không tải được gói nạp token. {{loi}}',
      dangHien: '{{so}} gói',
      dangHienLoc: '{{so}} / {{tong}} gói',
      xacNhanNgung: 'Ngừng bán gói {{ten}}?',
      xacNhanNgungMo: 'Tổ chức không chọn được gói này nữa. Yêu cầu đã gửi theo gói vẫn duyệt được.',
      xacNhanBat: 'Bán lại gói {{ten}}?',
      xacNhanBatMo: 'Gói hiện lại trong danh sách tổ chức chọn khi gửi yêu cầu nạp token.',
      daTao: 'Đã tạo gói {{ten}}.',
      daLuu: 'Đã lưu gói {{ten}}.',
      daBat: 'Đã bán lại gói {{ten}}.',
      daNgungBan: 'Đã ngừng bán gói {{ten}}.',
      hopTao: 'Tạo gói nạp token',
      hopSua: 'Sửa gói {{ten}}',
      oTen: 'Tên gói',
      oMa: 'Mã',
      oMaChoTen: 'Nhập tên để tạo mã',
      oMaTuSinh: 'Tạo từ tên, không đổi được sau khi lưu.',
      oMaKhongDoi: 'Mã không đổi được.',
      oToken: 'Số token Fox',
      oThoiHan: 'Thời hạn',
      oGia: 'Giá riêng (không bắt buộc)',
      oGiaGoiY: 'Bỏ trống thì giá theo đơn giá: {{gia}}.',
      oGiaChuaDonGia: 'Chưa đặt đơn giá token Fox: gói chỉ bán được khi có giá riêng.',
      loiTen: 'Nhập tên gói.',
      loiTenDai: 'Tên gói tối đa 120 ký tự.',
      loiToken: 'Số token Fox là số nguyên từ 1 tới 1.000.000.000.000.',
      loiThoiHan: 'Chọn 1, 3, 6, 12 tháng hoặc 1 tới 4 tuần.',
      loiGia: 'Giá là số USD lớn hơn 0, tối đa 2 chữ số thập phân, ví dụ 49.99.',
    },
    donGia: {
      tab: 'Đơn giá token Fox',
      oDonGia: 'Đơn giá cho 1 triệu token Fox',
      oDonGiaGoiY: 'Quyết giá của gói không có giá riêng và số token khi nạp theo số tiền.',
      oDonGiaTrong: 'Bỏ trống: chưa nạp theo số tiền được, gói chỉ bán khi có giá riêng.',
      oMucNap: 'Mức nạp gợi ý (USD)',
      oMucNapGoiY: 'Các số cách nhau bằng dấu phẩy, tối đa {{so}} mức.',
      loiDonGia: 'Đơn giá là số USD lớn hơn 0, tối đa 6 chữ số thập phân, ví dụ 2.5.',
      loiMucNap: 'Mỗi mức là số nguyên USD từ 1 tới 1.000.000.',
      loiMucNapNhieu: 'Tối đa {{so}} mức.',
      tyGiaDangAp: 'Tỷ giá USD→VND đang áp:',
      tyGiaGiaTri: '{{so}} ₫ ({{nguon}}, từ {{ngay}})',
      chuaCoTyGia: 'chưa có — giá VND để trống tới khi thêm ở tab Tỷ giá.',
      capNhat: 'Cập nhật:',
      luu: 'Lưu đơn giá',
      daLuu: 'Đã lưu đơn giá token Fox.',
      loiTai: 'Không tải được đơn giá token Fox. {{loi}}',
    },
    tyGia: {
      cotNguon: 'Nguồn',
      nguonThuCong: 'Nhập tay',
      nguonVcb: 'Vietcombank',
      dongBo: 'Đồng bộ tỷ giá',
      dangDongBo: 'Đang lấy...',
      nguonVcbLuc: 'Nguồn: Vietcombank · {{luc}}',
      loiDongBo: 'Không lấy được tỷ giá, nhập tay.',
    },
    heSo: {
      cot: 'Hệ số token',
      nhan: '×{{so}}',
      oHeSo: 'Hệ số token',
      oHeSoGoiY: 'Mỗi token thật của model trừ chừng này token Fox.',
      loiHeSo: 'Hệ số từ 0,1 tới 1000, tối đa 3 chữ số thập phân.',
      oTenGia: 'Tên model trong bảng giá',
      oTenGiaGoiY: 'Bỏ trống thì dùng model id.',
      goiY: 'Gợi ý hệ số',
      hopTieuDe: 'Gợi ý hệ số token',
      congThuc: 'Hệ số gợi ý = trung bình giá bán vào và ra (USD / 1 triệu token) ÷ {{gia}} USD.',
      chuaDonGia: 'Chưa đặt đơn giá token Fox ở Gói & thanh toán → Bảng giá model, nên chưa tính được gợi ý.',
      bangCaption: 'Hệ số token hiện tại và gợi ý theo model',
      cotModel: 'Model',
      cotGia: 'Giá bán (USD / 1 triệu)',
      cotHienTai: 'Hiện tại',
      cotGoiY: 'Gợi ý',
      giaVaoRa: 'Vào {{vao}} · Ra {{ra}}',
      apDung: 'Áp dụng',
      rong: 'Danh mục chưa có model nào',
      loiTai: 'Không tải được gợi ý. {{loi}}',
      ttOK: 'Có gợi ý',
      ttNoName: 'Chưa có tên model giá',
      ttNoPrice: 'Chưa có giá bán',
      ttNoRate: 'Thiếu tỷ giá sang USD',
      ttNoUnit: 'Chưa đặt đơn giá',
      ttUnavailable: 'Không đọc được bảng giá',
      xacNhanTieuDe: 'Đổi hệ số của {{ten}} thành {{heSo}}?',
      xacNhanThan: 'Từ lần ghi kế tiếp, mỗi token thật trừ {{moi}} token Fox thay vì {{cu}}. Số đã ghi không đổi.',
      xacNhanNut: 'Đổi thành {{heSo}}',
      daApDung: 'Đã đổi hệ số của {{ten}} thành {{heSo}}.',
    },
    yeuCau: {
      hopTieuDe: 'Gửi yêu cầu nạp token',
      cheDo: 'Cách nạp',
      cheDoGoi: 'Chọn gói',
      cheDoTien: 'Nạp theo số tiền',
      cheDoGiaHan: 'Gia hạn gói',
      oGoi: 'Gói nạp token',
      chuaCoGoi: 'Chưa có gói nào đang bán. Thử nạp theo số tiền.',
      chuaDonGia: 'Nền tảng chưa đặt đơn giá token Fox nên chưa nạp theo số tiền được.',
      loiChonGoi: 'Chọn một gói.',
      oSoTien: 'Số tiền',
      mucGoiY: 'Mức nạp gợi ý',
      donGiaLa: 'Đơn giá {{gia}} cho 1 triệu token Fox.',
      xemTruocToken: '≈ {{so}} token Fox',
      loiSoTienTrong: 'Chọn một mức hoặc nhập số tiền.',
      loiSoTienSai: 'Số tiền là số USD, tối đa 2 chữ số thập phân.',
      loiSoTienKhoang: 'Số tiền từ 1 tới 1.000.000 USD.',
      oLyDo: 'Lý do (không bắt buộc)',
      loiTai: 'Không tải được gói nạp token. {{loi}}',
      loaiNapToken: 'Nạp token',
      ndNapToken: '{{so}} token Fox, {{thoiHan}}',
      duyetNapToken: 'Duyệt nạp token',
    },
    chup: {
      goi: 'Gói {{ten}}',
      theoTien: 'Theo số tiền',
      tyGia: 'Tỷ giá {{so}} ngày {{ngay}}',
    },
    theoModel: {
      tieuDe: 'Theo model',
      caption: 'Token thật và token Fox theo model trong tháng',
      cotModel: 'Model',
      cotThat: 'Token thật',
      cotHeSo: 'Hệ số',
      cotFox: 'Token Fox',
      khongModel: 'Không ghi model',
      rong: 'Tháng này chưa có lượt gọi AI nào.',
      loi: 'Không tải được số theo model. {{loi}}',
    },
  },
};
